export { EndpointError } from "@smithy/util-endpoints";
